import { createContext } from "react";
import { AuthLoginPayload } from "../api/types/auth";
import { UserInfo } from "../api/types/user";

interface UserContext {
  detail: UserInfo | undefined;
  login: (payload: AuthLoginPayload) => void;
  logout: () => void;
  hasRole: (name: string) => boolean;
  isAdmin: () => boolean;
  isAccountManager: () => boolean;
  isPeopleEditor: () => boolean;
  isProfileManager: () => boolean;
  isProfileManagerTemp: () => boolean;
}

export const userContext = createContext<UserContext>({
  detail: undefined,
  login: (payload: AuthLoginPayload) => {},
  logout: () => {},
  hasRole: (name: string) => false,
  isAdmin: () => false,
  isAccountManager: () => false,
  isPeopleEditor: () => false,
  isProfileManager: () => false,
  isProfileManagerTemp: () => false,
});

export const ROLE = {
  ADMIN: "ROLE_ADMIN",
  USER: "ROLE_USER",
  ACCOUNT_MANAGER: "ROLE_ACCOUNT_MANAGER",
  PEOPLE_EDITOR: "ROLE_PEOPLE_EDITOR",
  PEOPLE_MANAGER: "ROLE_PROFILE_MANAGER",
  ROLE_PROFILE_MANAGER_TEMP_APPROVED: "ROLE_PROFILE_MANAGER_TEMP_APPROVED",
  RECOMMENDER: "ROLE_RECOMMENDER",
};
